export var IProductVariationMap;
(function (IProductVariationMap) {
    let IEntry;
    (function (IEntry) {
        let VariationDisplayType;
        (function (VariationDisplayType) {
            VariationDisplayType["VARIATION_DISPLAY_TYPE_UNKNOWN"] = "VARIATION_DISPLAY_TYPE_UNKNOWN";
            /**
             * one variation option available
             */
            VariationDisplayType["SINGLE"] = "SINGLE";
            /**
             * allOptionsHaveSwatches
             */
            VariationDisplayType["SWATCH"] = "SWATCH";
            /**
             * All options are less than or equal to 11 characters
             */
            VariationDisplayType["SHORT"] = "SHORT";
            /**
             * All options are longer than 11 characters and there are fewer than 6 options
             * Deprecated, defaults to DROPDOWN
             * @deprecated
             */
            VariationDisplayType["LONG"] = "LONG";
            /**
             * default
             */
            VariationDisplayType["DROPDOWN"] = "DROPDOWN";
        })(VariationDisplayType = IEntry.VariationDisplayType || (IEntry.VariationDisplayType = {}));
        let IValue;
        (function (IValue) {
            /**
             * Return an instance of IValue with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            IValue.build = (partial) => (Object.assign({ translation_overrides: [] }, (partial !== null && partial !== void 0 ? partial : {})));
        })(IValue = IEntry.IValue || (IEntry.IValue = {}));
        /**
         * Return an instance of IEntry with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IEntry.build = (partial) => (Object.assign({ values: [], entry_values: [], translation_overrides: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(IEntry = IProductVariationMap.IEntry || (IProductVariationMap.IEntry = {}));
    /**
     * Return an instance of IProductVariationMap with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IProductVariationMap.build = (partial) => (Object.assign({ entries: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IProductVariationMap || (IProductVariationMap = {}));
